/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './app/routes/__root'
import { Route as DashboardIndexImport } from './app/routes/_dashboard/index'
import { Route as redirectsSupportsImport } from './app/routes/(redirects)/supports'
import { Route as redirectsProfileImport } from './app/routes/(redirects)/profile'
import { Route as redirectsOrdersImport } from './app/routes/(redirects)/orders'
import { Route as redirectsDocumentsImport } from './app/routes/(redirects)/documents'
import { Route as redirectsAddressesImport } from './app/routes/(redirects)/addresses'
import { Route as DashboardDostavkeeIndexImport } from './app/routes/_dashboard/dostavkee/index'
import { Route as DashboardCorpdriveeIndexImport } from './app/routes/_dashboard/corpdrivee/index'
import { Route as AuthRegisterIndexImport } from './app/routes/_auth/register/index'
import { Route as AuthLoginIndexImport } from './app/routes/_auth/login/index'
import { Route as AuthInviteIndexImport } from './app/routes/_auth/invite/index'
import { Route as DashboardDostavkeeSidebarLayoutImport } from './app/routes/_dashboard/dostavkee/_sidebar-layout'
import { Route as DashboardCorpdriveeSidebarLayoutImport } from './app/routes/_dashboard/corpdrivee/_sidebar-layout'
import { Route as externalShareIdImport } from './app/routes/(external)/share.$id'
import { Route as DashboardCorpdriveeSidebarLayoutSupportsImport } from './app/routes/_dashboard/corpdrivee/_sidebar-layout/supports'
import { Route as DashboardCorpdriveeSidebarLayoutRideOrdersImport } from './app/routes/_dashboard/corpdrivee/_sidebar-layout/ride-orders'
import { Route as DashboardCorpdriveeSidebarLayoutEmployeesImport } from './app/routes/_dashboard/corpdrivee/_sidebar-layout/employees'
import { Route as DashboardCorpdriveeSidebarLayoutDocumentsImport } from './app/routes/_dashboard/corpdrivee/_sidebar-layout/documents'
import { Route as DashboardCorpdriveeSidebarLayoutBalanceImport } from './app/routes/_dashboard/corpdrivee/_sidebar-layout/balance'
import { Route as DashboardDostavkeeSidebarLayoutSupportsIndexImport } from './app/routes/_dashboard/dostavkee/_sidebar-layout/supports/index'
import { Route as DashboardDostavkeeSidebarLayoutProfileIndexImport } from './app/routes/_dashboard/dostavkee/_sidebar-layout/profile/index'
import { Route as DashboardDostavkeeSidebarLayoutOrdersIndexImport } from './app/routes/_dashboard/dostavkee/_sidebar-layout/orders/index'
import { Route as DashboardDostavkeeSidebarLayoutIntegrationIndexImport } from './app/routes/_dashboard/dostavkee/_sidebar-layout/integration/index'
import { Route as DashboardDostavkeeSidebarLayoutDocumentsIndexImport } from './app/routes/_dashboard/dostavkee/_sidebar-layout/documents/index'
import { Route as DashboardDostavkeeSidebarLayoutBalanceIndexImport } from './app/routes/_dashboard/dostavkee/_sidebar-layout/balance/index'
import { Route as DashboardDostavkeeSidebarLayoutAddressesIndexImport } from './app/routes/_dashboard/dostavkee/_sidebar-layout/addresses/index'
import { Route as DashboardCorpdriveeSidebarLayoutProfileIndexImport } from './app/routes/_dashboard/corpdrivee/_sidebar-layout/profile/index'
import { Route as DashboardDostavkeeSidebarLayoutOrdersTabsImport } from './app/routes/_dashboard/dostavkee/_sidebar-layout/orders/_tabs'
import { Route as DashboardCorpdriveeSidebarLayoutRideOrdersIdImport } from './app/routes/_dashboard/corpdrivee/_sidebar-layout/ride-orders_.$id'
import { Route as DashboardDostavkeeSidebarLayoutOrdersCreateIndexImport } from './app/routes/_dashboard/dostavkee/_sidebar-layout/orders/create/index'
import { Route as DashboardDostavkeeSidebarLayoutOrdersPublicidIndexImport } from './app/routes/_dashboard/dostavkee/_sidebar-layout/orders/$public_id/index'
import { Route as DashboardDostavkeeSidebarLayoutOrdersTabsSearchImport } from './app/routes/_dashboard/dostavkee/_sidebar-layout/orders/_tabs/search'
import { Route as DashboardDostavkeeSidebarLayoutOrdersTabsArchiveImport } from './app/routes/_dashboard/dostavkee/_sidebar-layout/orders/_tabs/archive'
import { Route as DashboardDostavkeeSidebarLayoutOrdersTabsActiveImport } from './app/routes/_dashboard/dostavkee/_sidebar-layout/orders/_tabs/active'

// Create Virtual Routes

const DashboardLazyImport = createFileRoute('/_dashboard')()
const AuthLazyImport = createFileRoute('/_auth')()
const DashboardDostavkeeImport = createFileRoute('/_dashboard/dostavkee')()
const DashboardCorpdriveeImport = createFileRoute('/_dashboard/corpdrivee')()
const DashboardDostavkeeCityNotAvailableLazyImport = createFileRoute(
  '/_dashboard/dostavkee/city-not-available',
)()
const DashboardCorpdriveeCityNotAvailableLazyImport = createFileRoute(
  '/_dashboard/corpdrivee/city-not-available',
)()
const DashboardDostavkeeSidebarLayoutOrdersImport = createFileRoute(
  '/_dashboard/dostavkee/_sidebar-layout/orders',
)()
const AuthRegisterEmailIndexLazyImport = createFileRoute(
  '/_auth/register/email/',
)()
const AuthRegisterCompanyIndexLazyImport = createFileRoute(
  '/_auth/register/company/',
)()
const AuthRegisterCategoryIndexLazyImport = createFileRoute(
  '/_auth/register/category/',
)()
const AuthLoginResetPasswordIndexLazyImport = createFileRoute(
  '/_auth/login/reset-password/',
)()
const AuthLoginResetPasswordConfirmIndexLazyImport = createFileRoute(
  '/_auth/login/reset-password/confirm/',
)()

// Create/Update Routes

const DashboardLazyRoute = DashboardLazyImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./app/routes/_dashboard.lazy').then((d) => d.Route),
)

const AuthLazyRoute = AuthLazyImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./app/routes/_auth.lazy').then((d) => d.Route))

const DashboardDostavkeeRoute = DashboardDostavkeeImport.update({
  path: '/dostavkee',
  getParentRoute: () => DashboardLazyRoute,
} as any)

const DashboardCorpdriveeRoute = DashboardCorpdriveeImport.update({
  path: '/corpdrivee',
  getParentRoute: () => DashboardLazyRoute,
} as any)

const DashboardIndexRoute = DashboardIndexImport.update({
  path: '/',
  getParentRoute: () => DashboardLazyRoute,
} as any)

const redirectsSupportsRoute = redirectsSupportsImport.update({
  path: '/supports',
  getParentRoute: () => rootRoute,
} as any)

const redirectsProfileRoute = redirectsProfileImport.update({
  path: '/profile',
  getParentRoute: () => rootRoute,
} as any)

const redirectsOrdersRoute = redirectsOrdersImport.update({
  path: '/orders',
  getParentRoute: () => rootRoute,
} as any)

const redirectsDocumentsRoute = redirectsDocumentsImport.update({
  path: '/documents',
  getParentRoute: () => rootRoute,
} as any)

const redirectsAddressesRoute = redirectsAddressesImport.update({
  path: '/addresses',
  getParentRoute: () => rootRoute,
} as any)

const DashboardDostavkeeIndexRoute = DashboardDostavkeeIndexImport.update({
  path: '/',
  getParentRoute: () => DashboardDostavkeeRoute,
} as any)

const DashboardCorpdriveeIndexRoute = DashboardCorpdriveeIndexImport.update({
  path: '/',
  getParentRoute: () => DashboardCorpdriveeRoute,
} as any)

const AuthRegisterIndexRoute = AuthRegisterIndexImport.update({
  path: '/register/',
  getParentRoute: () => AuthLazyRoute,
} as any).lazy(() =>
  import('./app/routes/_auth/register/index.lazy').then((d) => d.Route),
)

const AuthLoginIndexRoute = AuthLoginIndexImport.update({
  path: '/login/',
  getParentRoute: () => AuthLazyRoute,
} as any).lazy(() =>
  import('./app/routes/_auth/login/index.lazy').then((d) => d.Route),
)

const AuthInviteIndexRoute = AuthInviteIndexImport.update({
  path: '/invite/',
  getParentRoute: () => AuthLazyRoute,
} as any).lazy(() =>
  import('./app/routes/_auth/invite/index.lazy').then((d) => d.Route),
)

const DashboardDostavkeeCityNotAvailableLazyRoute =
  DashboardDostavkeeCityNotAvailableLazyImport.update({
    path: '/city-not-available',
    getParentRoute: () => DashboardDostavkeeRoute,
  } as any).lazy(() =>
    import('./app/routes/_dashboard/dostavkee/city-not-available.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardCorpdriveeCityNotAvailableLazyRoute =
  DashboardCorpdriveeCityNotAvailableLazyImport.update({
    path: '/city-not-available',
    getParentRoute: () => DashboardCorpdriveeRoute,
  } as any).lazy(() =>
    import('./app/routes/_dashboard/corpdrivee/city-not-available.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardDostavkeeSidebarLayoutRoute =
  DashboardDostavkeeSidebarLayoutImport.update({
    id: '/_sidebar-layout',
    getParentRoute: () => DashboardDostavkeeRoute,
  } as any).lazy(() =>
    import('./app/routes/_dashboard/dostavkee/_sidebar-layout.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardCorpdriveeSidebarLayoutRoute =
  DashboardCorpdriveeSidebarLayoutImport.update({
    id: '/_sidebar-layout',
    getParentRoute: () => DashboardCorpdriveeRoute,
  } as any).lazy(() =>
    import('./app/routes/_dashboard/corpdrivee/_sidebar-layout.lazy').then(
      (d) => d.Route,
    ),
  )

const externalShareIdRoute = externalShareIdImport
  .update({
    path: '/share/$id',
    getParentRoute: () => rootRoute,
  } as any)
  .lazy(() =>
    import('./app/routes/(external)/share.$id.lazy').then((d) => d.Route),
  )

const DashboardDostavkeeSidebarLayoutOrdersRoute =
  DashboardDostavkeeSidebarLayoutOrdersImport.update({
    path: '/orders',
    getParentRoute: () => DashboardDostavkeeSidebarLayoutRoute,
  } as any)

const AuthRegisterEmailIndexLazyRoute = AuthRegisterEmailIndexLazyImport.update(
  {
    path: '/register/email/',
    getParentRoute: () => AuthLazyRoute,
  } as any,
).lazy(() =>
  import('./app/routes/_auth/register/email/index.lazy').then((d) => d.Route),
)

const AuthRegisterCompanyIndexLazyRoute =
  AuthRegisterCompanyIndexLazyImport.update({
    path: '/register/company/',
    getParentRoute: () => AuthLazyRoute,
  } as any).lazy(() =>
    import('./app/routes/_auth/register/company/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthRegisterCategoryIndexLazyRoute =
  AuthRegisterCategoryIndexLazyImport.update({
    path: '/register/category/',
    getParentRoute: () => AuthLazyRoute,
  } as any).lazy(() =>
    import('./app/routes/_auth/register/category/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthLoginResetPasswordIndexLazyRoute =
  AuthLoginResetPasswordIndexLazyImport.update({
    path: '/login/reset-password/',
    getParentRoute: () => AuthLazyRoute,
  } as any).lazy(() =>
    import('./app/routes/_auth/login/reset-password/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardCorpdriveeSidebarLayoutSupportsRoute =
  DashboardCorpdriveeSidebarLayoutSupportsImport.update({
    path: '/supports',
    getParentRoute: () => DashboardCorpdriveeSidebarLayoutRoute,
  } as any).lazy(() =>
    import(
      './app/routes/_dashboard/corpdrivee/_sidebar-layout/supports.lazy'
    ).then((d) => d.Route),
  )

const DashboardCorpdriveeSidebarLayoutRideOrdersRoute =
  DashboardCorpdriveeSidebarLayoutRideOrdersImport.update({
    path: '/ride-orders',
    getParentRoute: () => DashboardCorpdriveeSidebarLayoutRoute,
  } as any).lazy(() =>
    import(
      './app/routes/_dashboard/corpdrivee/_sidebar-layout/ride-orders.lazy'
    ).then((d) => d.Route),
  )

const DashboardCorpdriveeSidebarLayoutEmployeesRoute =
  DashboardCorpdriveeSidebarLayoutEmployeesImport.update({
    path: '/employees',
    getParentRoute: () => DashboardCorpdriveeSidebarLayoutRoute,
  } as any).lazy(() =>
    import(
      './app/routes/_dashboard/corpdrivee/_sidebar-layout/employees.lazy'
    ).then((d) => d.Route),
  )

const DashboardCorpdriveeSidebarLayoutDocumentsRoute =
  DashboardCorpdriveeSidebarLayoutDocumentsImport.update({
    path: '/documents',
    getParentRoute: () => DashboardCorpdriveeSidebarLayoutRoute,
  } as any)

const DashboardCorpdriveeSidebarLayoutBalanceRoute =
  DashboardCorpdriveeSidebarLayoutBalanceImport.update({
    path: '/balance',
    getParentRoute: () => DashboardCorpdriveeSidebarLayoutRoute,
  } as any).lazy(() =>
    import(
      './app/routes/_dashboard/corpdrivee/_sidebar-layout/balance.lazy'
    ).then((d) => d.Route),
  )

const AuthLoginResetPasswordConfirmIndexLazyRoute =
  AuthLoginResetPasswordConfirmIndexLazyImport.update({
    path: '/login/reset-password/confirm/',
    getParentRoute: () => AuthLazyRoute,
  } as any).lazy(() =>
    import('./app/routes/_auth/login/reset-password/confirm/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardDostavkeeSidebarLayoutSupportsIndexRoute =
  DashboardDostavkeeSidebarLayoutSupportsIndexImport.update({
    path: '/supports/',
    getParentRoute: () => DashboardDostavkeeSidebarLayoutRoute,
  } as any).lazy(() =>
    import(
      './app/routes/_dashboard/dostavkee/_sidebar-layout/supports/index.lazy'
    ).then((d) => d.Route),
  )

const DashboardDostavkeeSidebarLayoutProfileIndexRoute =
  DashboardDostavkeeSidebarLayoutProfileIndexImport.update({
    path: '/profile/',
    getParentRoute: () => DashboardDostavkeeSidebarLayoutRoute,
  } as any).lazy(() =>
    import(
      './app/routes/_dashboard/dostavkee/_sidebar-layout/profile/index.lazy'
    ).then((d) => d.Route),
  )

const DashboardDostavkeeSidebarLayoutOrdersIndexRoute =
  DashboardDostavkeeSidebarLayoutOrdersIndexImport.update({
    path: '/',
    getParentRoute: () => DashboardDostavkeeSidebarLayoutOrdersRoute,
  } as any)

const DashboardDostavkeeSidebarLayoutIntegrationIndexRoute =
  DashboardDostavkeeSidebarLayoutIntegrationIndexImport.update({
    path: '/integration/',
    getParentRoute: () => DashboardDostavkeeSidebarLayoutRoute,
  } as any).lazy(() =>
    import(
      './app/routes/_dashboard/dostavkee/_sidebar-layout/integration/index.lazy'
    ).then((d) => d.Route),
  )

const DashboardDostavkeeSidebarLayoutDocumentsIndexRoute =
  DashboardDostavkeeSidebarLayoutDocumentsIndexImport.update({
    path: '/documents/',
    getParentRoute: () => DashboardDostavkeeSidebarLayoutRoute,
  } as any).lazy(() =>
    import(
      './app/routes/_dashboard/dostavkee/_sidebar-layout/documents/index.lazy'
    ).then((d) => d.Route),
  )

const DashboardDostavkeeSidebarLayoutBalanceIndexRoute =
  DashboardDostavkeeSidebarLayoutBalanceIndexImport.update({
    path: '/balance/',
    getParentRoute: () => DashboardDostavkeeSidebarLayoutRoute,
  } as any).lazy(() =>
    import(
      './app/routes/_dashboard/dostavkee/_sidebar-layout/balance/index.lazy'
    ).then((d) => d.Route),
  )

const DashboardDostavkeeSidebarLayoutAddressesIndexRoute =
  DashboardDostavkeeSidebarLayoutAddressesIndexImport.update({
    path: '/addresses/',
    getParentRoute: () => DashboardDostavkeeSidebarLayoutRoute,
  } as any).lazy(() =>
    import(
      './app/routes/_dashboard/dostavkee/_sidebar-layout/addresses/index.lazy'
    ).then((d) => d.Route),
  )

const DashboardCorpdriveeSidebarLayoutProfileIndexRoute =
  DashboardCorpdriveeSidebarLayoutProfileIndexImport.update({
    path: '/profile/',
    getParentRoute: () => DashboardCorpdriveeSidebarLayoutRoute,
  } as any).lazy(() =>
    import(
      './app/routes/_dashboard/corpdrivee/_sidebar-layout/profile/index.lazy'
    ).then((d) => d.Route),
  )

const DashboardDostavkeeSidebarLayoutOrdersTabsRoute =
  DashboardDostavkeeSidebarLayoutOrdersTabsImport.update({
    id: '/_tabs',
    getParentRoute: () => DashboardDostavkeeSidebarLayoutOrdersRoute,
  } as any)

const DashboardCorpdriveeSidebarLayoutRideOrdersIdRoute =
  DashboardCorpdriveeSidebarLayoutRideOrdersIdImport.update({
    path: '/ride-orders/$id',
    getParentRoute: () => DashboardCorpdriveeSidebarLayoutRoute,
  } as any).lazy(() =>
    import(
      './app/routes/_dashboard/corpdrivee/_sidebar-layout/ride-orders_.$id.lazy'
    ).then((d) => d.Route),
  )

const DashboardDostavkeeSidebarLayoutOrdersCreateIndexRoute =
  DashboardDostavkeeSidebarLayoutOrdersCreateIndexImport.update({
    path: '/create/',
    getParentRoute: () => DashboardDostavkeeSidebarLayoutOrdersRoute,
  } as any).lazy(() =>
    import(
      './app/routes/_dashboard/dostavkee/_sidebar-layout/orders/create/index.lazy'
    ).then((d) => d.Route),
  )

const DashboardDostavkeeSidebarLayoutOrdersPublicidIndexRoute =
  DashboardDostavkeeSidebarLayoutOrdersPublicidIndexImport.update({
    path: '/$public_id/',
    getParentRoute: () => DashboardDostavkeeSidebarLayoutOrdersRoute,
  } as any).lazy(() =>
    import(
      './app/routes/_dashboard/dostavkee/_sidebar-layout/orders/$public_id/index.lazy'
    ).then((d) => d.Route),
  )

const DashboardDostavkeeSidebarLayoutOrdersTabsSearchRoute =
  DashboardDostavkeeSidebarLayoutOrdersTabsSearchImport.update({
    path: '/search',
    getParentRoute: () => DashboardDostavkeeSidebarLayoutOrdersTabsRoute,
  } as any).lazy(() =>
    import(
      './app/routes/_dashboard/dostavkee/_sidebar-layout/orders/_tabs/search.lazy'
    ).then((d) => d.Route),
  )

const DashboardDostavkeeSidebarLayoutOrdersTabsArchiveRoute =
  DashboardDostavkeeSidebarLayoutOrdersTabsArchiveImport.update({
    path: '/archive',
    getParentRoute: () => DashboardDostavkeeSidebarLayoutOrdersTabsRoute,
  } as any).lazy(() =>
    import(
      './app/routes/_dashboard/dostavkee/_sidebar-layout/orders/_tabs/archive.lazy'
    ).then((d) => d.Route),
  )

const DashboardDostavkeeSidebarLayoutOrdersTabsActiveRoute =
  DashboardDostavkeeSidebarLayoutOrdersTabsActiveImport.update({
    path: '/active',
    getParentRoute: () => DashboardDostavkeeSidebarLayoutOrdersTabsRoute,
  } as any).lazy(() =>
    import(
      './app/routes/_dashboard/dostavkee/_sidebar-layout/orders/_tabs/active.lazy'
    ).then((d) => d.Route),
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthLazyImport
      parentRoute: typeof rootRoute
    }
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof DashboardLazyImport
      parentRoute: typeof rootRoute
    }
    '/(redirects)/addresses': {
      id: '/addresses'
      path: '/addresses'
      fullPath: '/addresses'
      preLoaderRoute: typeof redirectsAddressesImport
      parentRoute: typeof rootRoute
    }
    '/(redirects)/documents': {
      id: '/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof redirectsDocumentsImport
      parentRoute: typeof rootRoute
    }
    '/(redirects)/orders': {
      id: '/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof redirectsOrdersImport
      parentRoute: typeof rootRoute
    }
    '/(redirects)/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof redirectsProfileImport
      parentRoute: typeof rootRoute
    }
    '/(redirects)/supports': {
      id: '/supports'
      path: '/supports'
      fullPath: '/supports'
      preLoaderRoute: typeof redirectsSupportsImport
      parentRoute: typeof rootRoute
    }
    '/_dashboard/': {
      id: '/_dashboard/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof DashboardIndexImport
      parentRoute: typeof DashboardLazyImport
    }
    '/(external)/share/$id': {
      id: '/share/$id'
      path: '/share/$id'
      fullPath: '/share/$id'
      preLoaderRoute: typeof externalShareIdImport
      parentRoute: typeof rootRoute
    }
    '/_dashboard/corpdrivee': {
      id: '/_dashboard/corpdrivee'
      path: '/corpdrivee'
      fullPath: '/corpdrivee'
      preLoaderRoute: typeof DashboardCorpdriveeImport
      parentRoute: typeof DashboardLazyImport
    }
    '/_dashboard/corpdrivee/_sidebar-layout': {
      id: '/_dashboard/corpdrivee/_sidebar-layout'
      path: '/corpdrivee'
      fullPath: '/corpdrivee'
      preLoaderRoute: typeof DashboardCorpdriveeSidebarLayoutImport
      parentRoute: typeof DashboardCorpdriveeRoute
    }
    '/_dashboard/dostavkee': {
      id: '/_dashboard/dostavkee'
      path: '/dostavkee'
      fullPath: '/dostavkee'
      preLoaderRoute: typeof DashboardDostavkeeImport
      parentRoute: typeof DashboardLazyImport
    }
    '/_dashboard/dostavkee/_sidebar-layout': {
      id: '/_dashboard/dostavkee/_sidebar-layout'
      path: '/dostavkee'
      fullPath: '/dostavkee'
      preLoaderRoute: typeof DashboardDostavkeeSidebarLayoutImport
      parentRoute: typeof DashboardDostavkeeRoute
    }
    '/_dashboard/corpdrivee/city-not-available': {
      id: '/_dashboard/corpdrivee/city-not-available'
      path: '/city-not-available'
      fullPath: '/corpdrivee/city-not-available'
      preLoaderRoute: typeof DashboardCorpdriveeCityNotAvailableLazyImport
      parentRoute: typeof DashboardCorpdriveeImport
    }
    '/_dashboard/dostavkee/city-not-available': {
      id: '/_dashboard/dostavkee/city-not-available'
      path: '/city-not-available'
      fullPath: '/dostavkee/city-not-available'
      preLoaderRoute: typeof DashboardDostavkeeCityNotAvailableLazyImport
      parentRoute: typeof DashboardDostavkeeImport
    }
    '/_auth/invite/': {
      id: '/_auth/invite/'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof AuthInviteIndexImport
      parentRoute: typeof AuthLazyImport
    }
    '/_auth/login/': {
      id: '/_auth/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginIndexImport
      parentRoute: typeof AuthLazyImport
    }
    '/_auth/register/': {
      id: '/_auth/register/'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthRegisterIndexImport
      parentRoute: typeof AuthLazyImport
    }
    '/_dashboard/corpdrivee/': {
      id: '/_dashboard/corpdrivee/'
      path: '/'
      fullPath: '/corpdrivee/'
      preLoaderRoute: typeof DashboardCorpdriveeIndexImport
      parentRoute: typeof DashboardCorpdriveeImport
    }
    '/_dashboard/dostavkee/': {
      id: '/_dashboard/dostavkee/'
      path: '/'
      fullPath: '/dostavkee/'
      preLoaderRoute: typeof DashboardDostavkeeIndexImport
      parentRoute: typeof DashboardDostavkeeImport
    }
    '/_dashboard/corpdrivee/_sidebar-layout/balance': {
      id: '/_dashboard/corpdrivee/_sidebar-layout/balance'
      path: '/balance'
      fullPath: '/corpdrivee/balance'
      preLoaderRoute: typeof DashboardCorpdriveeSidebarLayoutBalanceImport
      parentRoute: typeof DashboardCorpdriveeSidebarLayoutImport
    }
    '/_dashboard/corpdrivee/_sidebar-layout/documents': {
      id: '/_dashboard/corpdrivee/_sidebar-layout/documents'
      path: '/documents'
      fullPath: '/corpdrivee/documents'
      preLoaderRoute: typeof DashboardCorpdriveeSidebarLayoutDocumentsImport
      parentRoute: typeof DashboardCorpdriveeSidebarLayoutImport
    }
    '/_dashboard/corpdrivee/_sidebar-layout/employees': {
      id: '/_dashboard/corpdrivee/_sidebar-layout/employees'
      path: '/employees'
      fullPath: '/corpdrivee/employees'
      preLoaderRoute: typeof DashboardCorpdriveeSidebarLayoutEmployeesImport
      parentRoute: typeof DashboardCorpdriveeSidebarLayoutImport
    }
    '/_dashboard/corpdrivee/_sidebar-layout/ride-orders': {
      id: '/_dashboard/corpdrivee/_sidebar-layout/ride-orders'
      path: '/ride-orders'
      fullPath: '/corpdrivee/ride-orders'
      preLoaderRoute: typeof DashboardCorpdriveeSidebarLayoutRideOrdersImport
      parentRoute: typeof DashboardCorpdriveeSidebarLayoutImport
    }
    '/_dashboard/corpdrivee/_sidebar-layout/supports': {
      id: '/_dashboard/corpdrivee/_sidebar-layout/supports'
      path: '/supports'
      fullPath: '/corpdrivee/supports'
      preLoaderRoute: typeof DashboardCorpdriveeSidebarLayoutSupportsImport
      parentRoute: typeof DashboardCorpdriveeSidebarLayoutImport
    }
    '/_auth/login/reset-password/': {
      id: '/_auth/login/reset-password/'
      path: '/login/reset-password'
      fullPath: '/login/reset-password'
      preLoaderRoute: typeof AuthLoginResetPasswordIndexLazyImport
      parentRoute: typeof AuthLazyImport
    }
    '/_auth/register/category/': {
      id: '/_auth/register/category/'
      path: '/register/category'
      fullPath: '/register/category'
      preLoaderRoute: typeof AuthRegisterCategoryIndexLazyImport
      parentRoute: typeof AuthLazyImport
    }
    '/_auth/register/company/': {
      id: '/_auth/register/company/'
      path: '/register/company'
      fullPath: '/register/company'
      preLoaderRoute: typeof AuthRegisterCompanyIndexLazyImport
      parentRoute: typeof AuthLazyImport
    }
    '/_auth/register/email/': {
      id: '/_auth/register/email/'
      path: '/register/email'
      fullPath: '/register/email'
      preLoaderRoute: typeof AuthRegisterEmailIndexLazyImport
      parentRoute: typeof AuthLazyImport
    }
    '/_dashboard/corpdrivee/_sidebar-layout/ride-orders/$id': {
      id: '/_dashboard/corpdrivee/_sidebar-layout/ride-orders/$id'
      path: '/ride-orders/$id'
      fullPath: '/corpdrivee/ride-orders/$id'
      preLoaderRoute: typeof DashboardCorpdriveeSidebarLayoutRideOrdersIdImport
      parentRoute: typeof DashboardCorpdriveeSidebarLayoutImport
    }
    '/_dashboard/dostavkee/_sidebar-layout/orders': {
      id: '/_dashboard/dostavkee/_sidebar-layout/orders'
      path: '/orders'
      fullPath: '/dostavkee/orders'
      preLoaderRoute: typeof DashboardDostavkeeSidebarLayoutOrdersImport
      parentRoute: typeof DashboardDostavkeeSidebarLayoutImport
    }
    '/_dashboard/dostavkee/_sidebar-layout/orders/_tabs': {
      id: '/_dashboard/dostavkee/_sidebar-layout/orders/_tabs'
      path: '/orders'
      fullPath: '/dostavkee/orders'
      preLoaderRoute: typeof DashboardDostavkeeSidebarLayoutOrdersTabsImport
      parentRoute: typeof DashboardDostavkeeSidebarLayoutOrdersRoute
    }
    '/_dashboard/corpdrivee/_sidebar-layout/profile/': {
      id: '/_dashboard/corpdrivee/_sidebar-layout/profile/'
      path: '/profile'
      fullPath: '/corpdrivee/profile'
      preLoaderRoute: typeof DashboardCorpdriveeSidebarLayoutProfileIndexImport
      parentRoute: typeof DashboardCorpdriveeSidebarLayoutImport
    }
    '/_dashboard/dostavkee/_sidebar-layout/addresses/': {
      id: '/_dashboard/dostavkee/_sidebar-layout/addresses/'
      path: '/addresses'
      fullPath: '/dostavkee/addresses'
      preLoaderRoute: typeof DashboardDostavkeeSidebarLayoutAddressesIndexImport
      parentRoute: typeof DashboardDostavkeeSidebarLayoutImport
    }
    '/_dashboard/dostavkee/_sidebar-layout/balance/': {
      id: '/_dashboard/dostavkee/_sidebar-layout/balance/'
      path: '/balance'
      fullPath: '/dostavkee/balance'
      preLoaderRoute: typeof DashboardDostavkeeSidebarLayoutBalanceIndexImport
      parentRoute: typeof DashboardDostavkeeSidebarLayoutImport
    }
    '/_dashboard/dostavkee/_sidebar-layout/documents/': {
      id: '/_dashboard/dostavkee/_sidebar-layout/documents/'
      path: '/documents'
      fullPath: '/dostavkee/documents'
      preLoaderRoute: typeof DashboardDostavkeeSidebarLayoutDocumentsIndexImport
      parentRoute: typeof DashboardDostavkeeSidebarLayoutImport
    }
    '/_dashboard/dostavkee/_sidebar-layout/integration/': {
      id: '/_dashboard/dostavkee/_sidebar-layout/integration/'
      path: '/integration'
      fullPath: '/dostavkee/integration'
      preLoaderRoute: typeof DashboardDostavkeeSidebarLayoutIntegrationIndexImport
      parentRoute: typeof DashboardDostavkeeSidebarLayoutImport
    }
    '/_dashboard/dostavkee/_sidebar-layout/orders/': {
      id: '/_dashboard/dostavkee/_sidebar-layout/orders/'
      path: '/'
      fullPath: '/dostavkee/orders/'
      preLoaderRoute: typeof DashboardDostavkeeSidebarLayoutOrdersIndexImport
      parentRoute: typeof DashboardDostavkeeSidebarLayoutOrdersImport
    }
    '/_dashboard/dostavkee/_sidebar-layout/profile/': {
      id: '/_dashboard/dostavkee/_sidebar-layout/profile/'
      path: '/profile'
      fullPath: '/dostavkee/profile'
      preLoaderRoute: typeof DashboardDostavkeeSidebarLayoutProfileIndexImport
      parentRoute: typeof DashboardDostavkeeSidebarLayoutImport
    }
    '/_dashboard/dostavkee/_sidebar-layout/supports/': {
      id: '/_dashboard/dostavkee/_sidebar-layout/supports/'
      path: '/supports'
      fullPath: '/dostavkee/supports'
      preLoaderRoute: typeof DashboardDostavkeeSidebarLayoutSupportsIndexImport
      parentRoute: typeof DashboardDostavkeeSidebarLayoutImport
    }
    '/_auth/login/reset-password/confirm/': {
      id: '/_auth/login/reset-password/confirm/'
      path: '/login/reset-password/confirm'
      fullPath: '/login/reset-password/confirm'
      preLoaderRoute: typeof AuthLoginResetPasswordConfirmIndexLazyImport
      parentRoute: typeof AuthLazyImport
    }
    '/_dashboard/dostavkee/_sidebar-layout/orders/_tabs/active': {
      id: '/_dashboard/dostavkee/_sidebar-layout/orders/_tabs/active'
      path: '/active'
      fullPath: '/dostavkee/orders/active'
      preLoaderRoute: typeof DashboardDostavkeeSidebarLayoutOrdersTabsActiveImport
      parentRoute: typeof DashboardDostavkeeSidebarLayoutOrdersTabsImport
    }
    '/_dashboard/dostavkee/_sidebar-layout/orders/_tabs/archive': {
      id: '/_dashboard/dostavkee/_sidebar-layout/orders/_tabs/archive'
      path: '/archive'
      fullPath: '/dostavkee/orders/archive'
      preLoaderRoute: typeof DashboardDostavkeeSidebarLayoutOrdersTabsArchiveImport
      parentRoute: typeof DashboardDostavkeeSidebarLayoutOrdersTabsImport
    }
    '/_dashboard/dostavkee/_sidebar-layout/orders/_tabs/search': {
      id: '/_dashboard/dostavkee/_sidebar-layout/orders/_tabs/search'
      path: '/search'
      fullPath: '/dostavkee/orders/search'
      preLoaderRoute: typeof DashboardDostavkeeSidebarLayoutOrdersTabsSearchImport
      parentRoute: typeof DashboardDostavkeeSidebarLayoutOrdersTabsImport
    }
    '/_dashboard/dostavkee/_sidebar-layout/orders/$public_id/': {
      id: '/_dashboard/dostavkee/_sidebar-layout/orders/$public_id/'
      path: '/$public_id'
      fullPath: '/dostavkee/orders/$public_id'
      preLoaderRoute: typeof DashboardDostavkeeSidebarLayoutOrdersPublicidIndexImport
      parentRoute: typeof DashboardDostavkeeSidebarLayoutOrdersImport
    }
    '/_dashboard/dostavkee/_sidebar-layout/orders/create/': {
      id: '/_dashboard/dostavkee/_sidebar-layout/orders/create/'
      path: '/create'
      fullPath: '/dostavkee/orders/create'
      preLoaderRoute: typeof DashboardDostavkeeSidebarLayoutOrdersCreateIndexImport
      parentRoute: typeof DashboardDostavkeeSidebarLayoutOrdersImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  AuthLazyRoute: AuthLazyRoute.addChildren({
    AuthInviteIndexRoute,
    AuthLoginIndexRoute,
    AuthRegisterIndexRoute,
    AuthLoginResetPasswordIndexLazyRoute,
    AuthRegisterCategoryIndexLazyRoute,
    AuthRegisterCompanyIndexLazyRoute,
    AuthRegisterEmailIndexLazyRoute,
    AuthLoginResetPasswordConfirmIndexLazyRoute,
  }),
  DashboardLazyRoute: DashboardLazyRoute.addChildren({
    DashboardIndexRoute,
    DashboardCorpdriveeRoute: DashboardCorpdriveeRoute.addChildren({
      DashboardCorpdriveeSidebarLayoutRoute:
        DashboardCorpdriveeSidebarLayoutRoute.addChildren({
          DashboardCorpdriveeSidebarLayoutBalanceRoute,
          DashboardCorpdriveeSidebarLayoutDocumentsRoute,
          DashboardCorpdriveeSidebarLayoutEmployeesRoute,
          DashboardCorpdriveeSidebarLayoutRideOrdersRoute,
          DashboardCorpdriveeSidebarLayoutSupportsRoute,
          DashboardCorpdriveeSidebarLayoutRideOrdersIdRoute,
          DashboardCorpdriveeSidebarLayoutProfileIndexRoute,
        }),
      DashboardCorpdriveeCityNotAvailableLazyRoute,
      DashboardCorpdriveeIndexRoute,
    }),
    DashboardDostavkeeRoute: DashboardDostavkeeRoute.addChildren({
      DashboardDostavkeeSidebarLayoutRoute:
        DashboardDostavkeeSidebarLayoutRoute.addChildren({
          DashboardDostavkeeSidebarLayoutOrdersRoute:
            DashboardDostavkeeSidebarLayoutOrdersRoute.addChildren({
              DashboardDostavkeeSidebarLayoutOrdersTabsRoute:
                DashboardDostavkeeSidebarLayoutOrdersTabsRoute.addChildren({
                  DashboardDostavkeeSidebarLayoutOrdersTabsActiveRoute,
                  DashboardDostavkeeSidebarLayoutOrdersTabsArchiveRoute,
                  DashboardDostavkeeSidebarLayoutOrdersTabsSearchRoute,
                }),
              DashboardDostavkeeSidebarLayoutOrdersIndexRoute,
              DashboardDostavkeeSidebarLayoutOrdersPublicidIndexRoute,
              DashboardDostavkeeSidebarLayoutOrdersCreateIndexRoute,
            }),
          DashboardDostavkeeSidebarLayoutAddressesIndexRoute,
          DashboardDostavkeeSidebarLayoutBalanceIndexRoute,
          DashboardDostavkeeSidebarLayoutDocumentsIndexRoute,
          DashboardDostavkeeSidebarLayoutIntegrationIndexRoute,
          DashboardDostavkeeSidebarLayoutProfileIndexRoute,
          DashboardDostavkeeSidebarLayoutSupportsIndexRoute,
        }),
      DashboardDostavkeeCityNotAvailableLazyRoute,
      DashboardDostavkeeIndexRoute,
    }),
  }),
  redirectsAddressesRoute,
  redirectsDocumentsRoute,
  redirectsOrdersRoute,
  redirectsProfileRoute,
  redirectsSupportsRoute,
  externalShareIdRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_auth",
        "/_dashboard",
        "/addresses",
        "/documents",
        "/orders",
        "/profile",
        "/supports",
        "/share/$id"
      ]
    },
    "/_auth": {
      "filePath": "_auth.lazy.tsx",
      "children": [
        "/_auth/invite/",
        "/_auth/login/",
        "/_auth/register/",
        "/_auth/login/reset-password/",
        "/_auth/register/category/",
        "/_auth/register/company/",
        "/_auth/register/email/",
        "/_auth/login/reset-password/confirm/"
      ]
    },
    "/_dashboard": {
      "filePath": "_dashboard.lazy.tsx",
      "children": [
        "/_dashboard/",
        "/_dashboard/corpdrivee",
        "/_dashboard/dostavkee"
      ]
    },
    "/addresses": {
      "filePath": "(redirects)/addresses.tsx"
    },
    "/documents": {
      "filePath": "(redirects)/documents.tsx"
    },
    "/orders": {
      "filePath": "(redirects)/orders.tsx"
    },
    "/profile": {
      "filePath": "(redirects)/profile.tsx"
    },
    "/supports": {
      "filePath": "(redirects)/supports.tsx"
    },
    "/_dashboard/": {
      "filePath": "_dashboard/index.tsx",
      "parent": "/_dashboard"
    },
    "/share/$id": {
      "filePath": "(external)/share.$id.tsx"
    },
    "/_dashboard/corpdrivee": {
      "filePath": "_dashboard/corpdrivee",
      "parent": "/_dashboard",
      "children": [
        "/_dashboard/corpdrivee/_sidebar-layout",
        "/_dashboard/corpdrivee/city-not-available",
        "/_dashboard/corpdrivee/"
      ]
    },
    "/_dashboard/corpdrivee/_sidebar-layout": {
      "filePath": "_dashboard/corpdrivee/_sidebar-layout.tsx",
      "parent": "/_dashboard/corpdrivee",
      "children": [
        "/_dashboard/corpdrivee/_sidebar-layout/balance",
        "/_dashboard/corpdrivee/_sidebar-layout/documents",
        "/_dashboard/corpdrivee/_sidebar-layout/employees",
        "/_dashboard/corpdrivee/_sidebar-layout/ride-orders",
        "/_dashboard/corpdrivee/_sidebar-layout/supports",
        "/_dashboard/corpdrivee/_sidebar-layout/ride-orders/$id",
        "/_dashboard/corpdrivee/_sidebar-layout/profile/"
      ]
    },
    "/_dashboard/dostavkee": {
      "filePath": "_dashboard/dostavkee",
      "parent": "/_dashboard",
      "children": [
        "/_dashboard/dostavkee/_sidebar-layout",
        "/_dashboard/dostavkee/city-not-available",
        "/_dashboard/dostavkee/"
      ]
    },
    "/_dashboard/dostavkee/_sidebar-layout": {
      "filePath": "_dashboard/dostavkee/_sidebar-layout.tsx",
      "parent": "/_dashboard/dostavkee",
      "children": [
        "/_dashboard/dostavkee/_sidebar-layout/orders",
        "/_dashboard/dostavkee/_sidebar-layout/addresses/",
        "/_dashboard/dostavkee/_sidebar-layout/balance/",
        "/_dashboard/dostavkee/_sidebar-layout/documents/",
        "/_dashboard/dostavkee/_sidebar-layout/integration/",
        "/_dashboard/dostavkee/_sidebar-layout/profile/",
        "/_dashboard/dostavkee/_sidebar-layout/supports/"
      ]
    },
    "/_dashboard/corpdrivee/city-not-available": {
      "filePath": "_dashboard/corpdrivee/city-not-available.lazy.tsx",
      "parent": "/_dashboard/corpdrivee"
    },
    "/_dashboard/dostavkee/city-not-available": {
      "filePath": "_dashboard/dostavkee/city-not-available.lazy.tsx",
      "parent": "/_dashboard/dostavkee"
    },
    "/_auth/invite/": {
      "filePath": "_auth/invite/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/login/": {
      "filePath": "_auth/login/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/register/": {
      "filePath": "_auth/register/index.tsx",
      "parent": "/_auth"
    },
    "/_dashboard/corpdrivee/": {
      "filePath": "_dashboard/corpdrivee/index.tsx",
      "parent": "/_dashboard/corpdrivee"
    },
    "/_dashboard/dostavkee/": {
      "filePath": "_dashboard/dostavkee/index.tsx",
      "parent": "/_dashboard/dostavkee"
    },
    "/_dashboard/corpdrivee/_sidebar-layout/balance": {
      "filePath": "_dashboard/corpdrivee/_sidebar-layout/balance.tsx",
      "parent": "/_dashboard/corpdrivee/_sidebar-layout"
    },
    "/_dashboard/corpdrivee/_sidebar-layout/documents": {
      "filePath": "_dashboard/corpdrivee/_sidebar-layout/documents.tsx",
      "parent": "/_dashboard/corpdrivee/_sidebar-layout"
    },
    "/_dashboard/corpdrivee/_sidebar-layout/employees": {
      "filePath": "_dashboard/corpdrivee/_sidebar-layout/employees.tsx",
      "parent": "/_dashboard/corpdrivee/_sidebar-layout"
    },
    "/_dashboard/corpdrivee/_sidebar-layout/ride-orders": {
      "filePath": "_dashboard/corpdrivee/_sidebar-layout/ride-orders.tsx",
      "parent": "/_dashboard/corpdrivee/_sidebar-layout"
    },
    "/_dashboard/corpdrivee/_sidebar-layout/supports": {
      "filePath": "_dashboard/corpdrivee/_sidebar-layout/supports.tsx",
      "parent": "/_dashboard/corpdrivee/_sidebar-layout"
    },
    "/_auth/login/reset-password/": {
      "filePath": "_auth/login/reset-password/index.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/register/category/": {
      "filePath": "_auth/register/category/index.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/register/company/": {
      "filePath": "_auth/register/company/index.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/register/email/": {
      "filePath": "_auth/register/email/index.lazy.tsx",
      "parent": "/_auth"
    },
    "/_dashboard/corpdrivee/_sidebar-layout/ride-orders/$id": {
      "filePath": "_dashboard/corpdrivee/_sidebar-layout/ride-orders_.$id.tsx",
      "parent": "/_dashboard/corpdrivee/_sidebar-layout"
    },
    "/_dashboard/dostavkee/_sidebar-layout/orders": {
      "filePath": "_dashboard/dostavkee/_sidebar-layout/orders",
      "parent": "/_dashboard/dostavkee/_sidebar-layout",
      "children": [
        "/_dashboard/dostavkee/_sidebar-layout/orders/_tabs",
        "/_dashboard/dostavkee/_sidebar-layout/orders/",
        "/_dashboard/dostavkee/_sidebar-layout/orders/$public_id/",
        "/_dashboard/dostavkee/_sidebar-layout/orders/create/"
      ]
    },
    "/_dashboard/dostavkee/_sidebar-layout/orders/_tabs": {
      "filePath": "_dashboard/dostavkee/_sidebar-layout/orders/_tabs.tsx",
      "parent": "/_dashboard/dostavkee/_sidebar-layout/orders",
      "children": [
        "/_dashboard/dostavkee/_sidebar-layout/orders/_tabs/active",
        "/_dashboard/dostavkee/_sidebar-layout/orders/_tabs/archive",
        "/_dashboard/dostavkee/_sidebar-layout/orders/_tabs/search"
      ]
    },
    "/_dashboard/corpdrivee/_sidebar-layout/profile/": {
      "filePath": "_dashboard/corpdrivee/_sidebar-layout/profile/index.tsx",
      "parent": "/_dashboard/corpdrivee/_sidebar-layout"
    },
    "/_dashboard/dostavkee/_sidebar-layout/addresses/": {
      "filePath": "_dashboard/dostavkee/_sidebar-layout/addresses/index.tsx",
      "parent": "/_dashboard/dostavkee/_sidebar-layout"
    },
    "/_dashboard/dostavkee/_sidebar-layout/balance/": {
      "filePath": "_dashboard/dostavkee/_sidebar-layout/balance/index.tsx",
      "parent": "/_dashboard/dostavkee/_sidebar-layout"
    },
    "/_dashboard/dostavkee/_sidebar-layout/documents/": {
      "filePath": "_dashboard/dostavkee/_sidebar-layout/documents/index.tsx",
      "parent": "/_dashboard/dostavkee/_sidebar-layout"
    },
    "/_dashboard/dostavkee/_sidebar-layout/integration/": {
      "filePath": "_dashboard/dostavkee/_sidebar-layout/integration/index.tsx",
      "parent": "/_dashboard/dostavkee/_sidebar-layout"
    },
    "/_dashboard/dostavkee/_sidebar-layout/orders/": {
      "filePath": "_dashboard/dostavkee/_sidebar-layout/orders/index.tsx",
      "parent": "/_dashboard/dostavkee/_sidebar-layout/orders"
    },
    "/_dashboard/dostavkee/_sidebar-layout/profile/": {
      "filePath": "_dashboard/dostavkee/_sidebar-layout/profile/index.tsx",
      "parent": "/_dashboard/dostavkee/_sidebar-layout"
    },
    "/_dashboard/dostavkee/_sidebar-layout/supports/": {
      "filePath": "_dashboard/dostavkee/_sidebar-layout/supports/index.tsx",
      "parent": "/_dashboard/dostavkee/_sidebar-layout"
    },
    "/_auth/login/reset-password/confirm/": {
      "filePath": "_auth/login/reset-password/confirm/index.lazy.tsx",
      "parent": "/_auth"
    },
    "/_dashboard/dostavkee/_sidebar-layout/orders/_tabs/active": {
      "filePath": "_dashboard/dostavkee/_sidebar-layout/orders/_tabs/active.tsx",
      "parent": "/_dashboard/dostavkee/_sidebar-layout/orders/_tabs"
    },
    "/_dashboard/dostavkee/_sidebar-layout/orders/_tabs/archive": {
      "filePath": "_dashboard/dostavkee/_sidebar-layout/orders/_tabs/archive.tsx",
      "parent": "/_dashboard/dostavkee/_sidebar-layout/orders/_tabs"
    },
    "/_dashboard/dostavkee/_sidebar-layout/orders/_tabs/search": {
      "filePath": "_dashboard/dostavkee/_sidebar-layout/orders/_tabs/search.tsx",
      "parent": "/_dashboard/dostavkee/_sidebar-layout/orders/_tabs"
    },
    "/_dashboard/dostavkee/_sidebar-layout/orders/$public_id/": {
      "filePath": "_dashboard/dostavkee/_sidebar-layout/orders/$public_id/index.tsx",
      "parent": "/_dashboard/dostavkee/_sidebar-layout/orders"
    },
    "/_dashboard/dostavkee/_sidebar-layout/orders/create/": {
      "filePath": "_dashboard/dostavkee/_sidebar-layout/orders/create/index.tsx",
      "parent": "/_dashboard/dostavkee/_sidebar-layout/orders"
    }
  }
}
ROUTE_MANIFEST_END */
